import React from 'react';
import UnderConstructionScreen from './UnderConstructionScreen';

const CommunityForumScreen = () => (
    <UnderConstructionScreen
        eyebrow="Community Forum"
        icon="forum-outline"
        title="A place for hosts and families to connect."
        subtitle="We are building a community space where camp hosts, parents, and coaches can share ideas, ask questions, and support each other across the SnapCamp network."
        accentColor="#7C3AED"
        features={[
            {
                icon: 'account-group-outline',
                title: 'Host discussions',
                description: 'Connect with other camp operators to share what is working, troubleshoot challenges, and swap ideas on running great programs.',
            },
            {
                icon: 'chat-question-outline',
                title: 'Parent Q&A',
                description: 'Families will be able to ask questions, get recommendations, and share reviews with other parents in the community.',
            },
            {
                icon: 'star-circle-outline',
                title: 'Spotlights and stories',
                description: 'We will highlight stand-out camps, memorable camper stories, and community milestones from across the SnapCamp network.',
            },
        ]}
        contactPrompt="Want early access or have ideas for the forum?"
        contactEmail="community@snapcamp.ai"
    />
);

export default CommunityForumScreen;
